import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PRICING_PAGE, BRAND } from "@/lib/constants";
import { Flag, Timer, Users } from "lucide-react";

const trustIcons = { Flag, Timer, Users };
const trustItems = [
  { text: "Australian owned and supported", icon: "Flag" },
  { text: "Set up in under 10 minutes", icon: "Timer" },
  { text: "Used by 50+ trades businesses", icon: "Users" },
];

export default function PricingCTA() {
  const { cta } = PRICING_PAGE;

  return (
    <section
      data-testid="pricing-cta-section"
      className="bg-[#D4A84B] py-12 md:py-20"
      aria-label="Call to action"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl text-center">
        <h2
          className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] leading-tight tracking-tight mb-4"
          data-testid="pricing-cta-heading"
        >
          {cta.heading}
        </h2>

        <p className="text-[#1A1A1A]/80 text-base leading-relaxed max-w-2xl mx-auto mb-8">
          {cta.body}
        </p>

        <div className="space-y-3">
          <Link to={BRAND.signupPath}>
            {/* Stripe checkout will connect here */}
            <Button
              data-testid="pricing-final-cta"
              className="bg-[#1A1A1A] hover:bg-[#333333] text-white font-bold h-16 px-14 rounded-md shadow-lg hover:shadow-xl transition-all active:scale-95 text-lg tracking-wide"
            >
              {cta.ctaButton}
            </Button>
          </Link>
          <p className="text-sm text-[#1A1A1A]/70">{cta.secondary}</p>
        </div>

        {/* Trust indicators */}
        <div className="mt-10 pt-8 border-t border-[#1A1A1A]/10 flex flex-wrap justify-center gap-6 md:gap-10">
          {trustItems.map((item, i) => {
            const Icon = trustIcons[item.icon];
            return (
              <div
                key={item.text}
                className="flex items-center gap-2 text-sm text-[#1A1A1A]/70"
                data-testid={`pricing-cta-trust-${i}`}
              >
                {Icon && <Icon className="h-4 w-4 text-[#1A1A1A]" />}
                <span>{item.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
